"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _facepaint = _interopRequireDefault(require("facepaint"));
/**
 * When using the mq function in your code, specify four values in an array. For example:
 *
 *   mq({
 *     width: ['85%', '40%', '40%', '40%'],
 *   });
 *
 *   The positions in the array correspond to the media query breakpoints defined below.
 *
 *   Array position 0:  mobile device (up to 620px)
 *   Array position 1:  mobile/tablet (620px to 768px)
 *   Array position 2:  tablet (768px to 1024px)
 *   Array position 3:  desktop (greater than 1024px)
 * */

const widths = {
  mobile: '@media(min-width: 620px)',
  tablet: '@media(min-width: 768px)',
  desktop: '@media(min-width: 1024px)'
};
const mq = (0, _facepaint.default)([widths.mobile, widths.tablet, widths.desktop]);
var _default = exports.default = mq;